import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { motion } from "framer-motion";
import imgEvents from "../../../assets/img/img-events/images-events";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";

const buttonVariants = {
  hover: {
    // scale: [1, 1.2, 1, 1.2, 1, 1.2, 1, 1.2, 1, 1.2, 1],
    scale: 1.02,
    textShadow: "0 0 8px rgb(255, 255, 255)",
  },
};

const Events = () => {
  return (
    <main role="main" className="mc-fond-ecran">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          {imgEvents.map((event) => {
            return (
              <Col xs={12} sm={6} md={4} lg={3} key={event.id}>
                <Nav>
                  <NavLink className="text-center" to={event.path}>
                    <motion.div
                      className="text-dark fw-semibold"
                      variants={buttonVariants}
                      whileHover="hover"
                    >
                      <Card className="m-2 text-light">
                        <Card.Img
                          src={event.img}
                          alt={"Image évènement ?"}
                          className="img-fluid border border-2 border-primary"
                        />
                        <Card.ImgOverlay>
                          <Card.Title className="bg-secondary mc-rfs-5">
                            {event.title}
                          </Card.Title>
                          <Card.Text className="bg-dark-subtle px-2 mc-rfs-6 text-dark">
                            {event.subTitle}
                          </Card.Text>
                        </Card.ImgOverlay>
                      </Card>
                    </motion.div>
                  </NavLink>
                </Nav>
              </Col>
            );
          })}
        </Row>
      </Container>
    </main>
  );
};

export default Events;
